import { useRef, useEffect } from "react";

// Reliable muted-autoplay looping video. Works around React's `muted` attribute
// timing bug (which otherwise makes browsers block muted autoplay) by forcing
// the muted property + play() via a ref. When autoplay is false it only plays on hover.
export default function LoopVideo({ src, autoplay = true, className = "", ...rest }) {
  const ref = useRef(null);

  useEffect(() => {
    const v = ref.current;
    if (!v) return;
    v.muted = true;
    v.playsInline = true;
    if (!autoplay) return;
    const tryPlay = () => { const p = v.play(); if (p && p.catch) p.catch(() => {}); };
    tryPlay();
    // Play when it becomes visible (cards can start off-screen in scroll rows)
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) tryPlay(); }),
      { threshold: 0.25 }
    );
    io.observe(v);
    return () => io.disconnect();
  }, [src, autoplay]);

  return (
    <video
      ref={ref}
      src={src}
      muted
      loop
      playsInline
      autoPlay={autoplay}
      preload="auto"
      className={className}
      onMouseOver={(e) => { const p = e.currentTarget.play(); if (p && p.catch) p.catch(() => {}); }}
      onMouseOut={(e) => { if (!autoplay) e.currentTarget.pause?.(); }}
      {...rest}
    />
  );
}
